const getNestedError = (errors, name) => {
  const path = name.split(".");
  let currentError = errors;

  for (const segment of path) {
    if (!currentError || typeof currentError !== "object") {
      return null;
    }
    // Handle array indices
    if (segment.endsWith("]")) {
      const [arrayName, index] = segment.replace("]", "").split("[");
      currentError = currentError[arrayName]?.[parseInt(index)];
    } else {
      currentError = currentError[segment];
    }
  }
  return currentError?.message || null;
};

export default getNestedError;
